import quickEmailLabelSchedule from './quickEmailLabelSchedule.json'

interface QuickEmailLabelSource {
  /** 掲載枠の識別子（GA4 には出さない。運用時に週を追いやすくするための番号） */
  id: string
  label: string
}

export interface QuickEmailLabel extends QuickEmailLabelSource {
  /** 週替わり掲載枠の文言か（掲載期間外に戻る既定文言は false） */
  isScheduled: boolean
}

interface ScheduledQuickEmailLabel extends QuickEmailLabelSource {
  /** 掲載開始日（JST・YYYY-MM-DD。当日を含む） */
  startDate: string
  /** 掲載終了日（JST・YYYY-MM-DD。当日を含む） */
  endDate: string
}

const DEFAULT_LABEL: QuickEmailLabelSource = quickEmailLabelSchedule.default
const SCHEDULE: ScheduledQuickEmailLabel[] = quickEmailLabelSchedule.schedule

const JST_OFFSET_MS = 9 * 60 * 60 * 1000

/**
 * 端末のタイムゾーンに関係なく JST の暦日（YYYY-MM-DD）へ落とす。
 * 掲載期間は日本時間の日付で運用するため、比較は必ずこのキーで行う。
 */
function toJstDateKey(date: Date): string {
  return new Date(date.getTime() + JST_OFFSET_MS).toISOString().slice(0, 10)
}

function toQuickEmailLabel(
  source: QuickEmailLabelSource,
  isScheduled: boolean
): QuickEmailLabel {
  return { id: source.id, label: source.label, isScheduled }
}

/**
 * 完了画面「応募先にメール」の週替わり文言。掲載期間外（開始前・終了後）は既定文言へ戻す。
 */
export function resolveQuickEmailLabel(date: Date): QuickEmailLabel {
  const today = toJstDateKey(date)
  const scheduled = SCHEDULE.find(function (entry) {
    return entry.startDate <= today && today <= entry.endDate
  })
  return scheduled
    ? toQuickEmailLabel(scheduled, true)
    : toQuickEmailLabel(DEFAULT_LABEL, false)
}
